import React from "react";
import styled from "styled-components";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { useTranslation } from "react-i18next";
import { CURRENCY } from "../../../../../constants/DeliveryConstants";
import { formatPrice } from "../../../../../functions/formatters";

// Kleuren voor de grafieken
const COLORS = ["#F5E0B8", "#D7B1B1", "#C9E4CA", "#F7D2C4", "#F2C464", "#E8B422", "#C7B8EA", "#A3C6C6"];

const ProductDivisionPieChart = ({ topProductsByRevenue, processedProducts }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardTitle>{t("product_division_based_on_sales")}</CardTitle>
      <ChartContainer>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={topProductsByRevenue}
              dataKey="totalValue"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={120}
              fill="#8884d8"
              label={(entry) => `${entry.name}: ${CURRENCY + formatPrice(entry.totalValue)}`}
            >
              {topProductsByRevenue.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value, name, props) => [
                `${CURRENCY + formatPrice(value)} (${((value / processedProducts.reduce((sum, p) => sum + p.totalValue, 0)) * 100).toFixed(1)}%)`,
                props.payload.name,
              ]}
            />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </ChartContainer>
    </Card>
  );
};

const Card = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 1rem;
  margin-bottom: 1.5rem;
`;

const CardTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

const ChartContainer = styled.div`
  height: 24rem;
`;

export default ProductDivisionPieChart;
